module.exports = __webpack_public_path__ + "22043e8c7084d85807c5d97cfe604d27.gif";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/integralEvaluation/teacherSelfAssessment/simplespin.gif
// module id = 557
// module chunks = 0